import {
  Box, FormControl, FormLabel, Select, Text,
} from '@chakra-ui/react';
import { get } from '@submize/lodash';
import useUpdateField from '../useUpdateField';
import OptionsList from './OptionsList';

const SelectOptions = ({ field }) => {
  const [defaultValue, setDefaultValue] = useUpdateField(field, 'props.defaultValue');
  const options = get(field, 'props.options', []);

  return (
    <Box>
      <Text fontWeight="bold" mb="2">Select options</Text>
      <OptionsList field={field} />
      <FormControl mt="4">
        <FormLabel fontSize="sm" mb="1">Default value</FormLabel>
        <Select value={defaultValue} onChange={(e) => setDefaultValue(e.target.value)}>
          {options.map(({ key, value }) => <option key={key} value={key}>{value}</option>)}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectOptions;
